import React, { useState } from 'react'
import { supportedLanguages } from "../i18n";
import { useTranslation } from 'react-i18next';

const LangSwitcherIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" className="v-icon iconify iconify--custom" style={{ fontSize: '1em' }} width="0.95em" height="1em" viewBox="0 0 16 17" data-v-a9fb026a="">
    <g fill="none">
      <path d="M3.55361 6.03732C3.69459 5.90673 3.88578 5.83337 4.08513 5.83337C4.28448 5.83337 4.47567 5.90673 4.61665 6.03732L8.33803 9.48534L12.0594 6.03732C12.2012 5.91043 12.3911 5.84022 12.5882 5.84181C12.7854 5.8434 12.9739 5.91666 13.1133 6.04581C13.2527 6.17495 13.3318 6.34966 13.3335 6.5323C13.3352 6.71494 13.2594 6.89089 13.1225 7.02227L8.86955 10.9628C8.72857 11.0933 8.53738 11.1667 8.33803 11.1667C8.13869 11.1667 7.9475 11.0933 7.80652 10.9628L3.55361 7.02227C3.41267 6.89164 3.3335 6.7145 3.3335 6.52979C3.3335 6.34509 3.41267 6.16795 3.55361 6.03732Z" fill="currentColor"></path>
    </g>
  </svg>
);

export default function LanguageSwitcher({ className = ''}) {
  const { i18n } = useTranslation();
  const [langSwitcherDisabled, setLangSwitcherDisabled] = useState(true);

  const handleOnLangSwitch = (lang) => {
    i18n.changeLanguage(lang);
    setLangSwitcherDisabled(true);
    // set lang cookie with unlimited duration
    document.cookie = `lang=${lang};path=/;max-age=31536000`;
  }

  return (
    <div className={`lang-switcher ${className}`}>
      <button
        type="button"
        className="lang-switcher__current"
        onClick={() => setLangSwitcherDisabled((prev) => !prev)}
      >
        <span>{i18n.language.toUpperCase()}</span>
        <LangSwitcherIcon></LangSwitcherIcon>
      </button>
      <ul
        className="lang-switcher__list"
        hidden={langSwitcherDisabled}
      >
        {supportedLanguages.map((lang) => (
          <li key={lang}>
            <button
              type="button"
              className="lang-switcher__item"
              disabled={i18n.language === lang}
              onClick={() => handleOnLangSwitch(lang)}
            >{lang.toUpperCase()}</button>
          </li>
        ))}
      </ul>
    </div>
  )
}